import { UserRow, UserRowRoleType } from '@modules/users/store/types';
import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

export const renderUserNameAndEmailRowCell = (
  params: GridRenderCellParams<UserRow, string, unknown>,
) => {
  const { role } = params.row;

  if (role === UserRowRoleType.Suspended) {
    return (
      <Box
        sx={{
          textDecoration: 'line-through',
          color: (theme) => theme.palette.grey[500],
        }}
      >
        {params.value}
      </Box>
    );
  }

  return params.value;
};
